export class CorrectionSteps {
    constructor() {
        this.Correction = 0;
        this.AvaliableCorrections = [];
        this.CorrectionType = "LOWER";
    }
}
export class ComfortPositionParameters {
    constructor() {
        this.Channel = 0;
        this.Position1 = 0;
        this.Position2 = 0;
    }
}
export class InputOutputBlindParameters {
    constructor() {
        this.Channel = 0;
        this.InputModeBlind = InputModeBlind.Local;
        this.ButtonTypeBlind = ButtonTypeBlind.SingleButton;
    }
}
export var InputModeBlind;
(function (InputModeBlind) {
    InputModeBlind[InputModeBlind["Local"] = 0] = "Local";
    InputModeBlind[InputModeBlind["Central"] = 1] = "Central";
})(InputModeBlind || (InputModeBlind = {}));
export var ButtonTypeBlind;
(function (ButtonTypeBlind) {
    ButtonTypeBlind[ButtonTypeBlind["SingleButton"] = 0] = "SingleButton";
    ButtonTypeBlind[ButtonTypeBlind["DoubleButton"] = 1] = "DoubleButton";
})(ButtonTypeBlind || (ButtonTypeBlind = {}));
export class StateOfTurnOnBlindDeviceParameters {
    constructor() {
        this.Channel = 0;
        this.State = BlindTurnOnState.DoNothing;
        this.BlindPosition = 0;
    }
}
export var BlindTurnOnState;
(function (BlindTurnOnState) {
    BlindTurnOnState[BlindTurnOnState["OpenBlind"] = 0] = "OpenBlind";
    BlindTurnOnState[BlindTurnOnState["CloseBlind"] = 1] = "CloseBlind";
    BlindTurnOnState[BlindTurnOnState["DoNothing"] = 2] = "DoNothing";
    BlindTurnOnState[BlindTurnOnState["OpenPercentage"] = 3] = "OpenPercentage";
})(BlindTurnOnState || (BlindTurnOnState = {}));
//# sourceMappingURL=BlindConfigParameters.js.map